<template lang="html">
  <img class="pt-3 mb-4" src="@/assets/logo.svg" alt="logo" width="250" />
  <h1 class="p-0 mb-4">Thank you!</h1>
  <h2 class="subtitle">
    Scan the QR code on the claw machine and start the game.
  </h2>
  <h2 class="subtitle mb-4">Good luck!</h2>
  <div class="center mb-4">
    <img
      :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getSavedDataId"
      width="250"
    />
  </div>
  <button
    type="button"
    class="btn btn-primary btn-lg rounded-pill"
    @click="goToUrl()"
  >
    <span>Go to TOPdesk</span>
  </button>
</template>

<script>
export default {
  name: "QrCodeScreen",
  data: () => ({}),
  computed: {
    getSavedDataId: function () {
      let savedData = this.$store.getters.getSavedData;
      if (savedData !== null) {
        return savedData._id;
      }
      return false;
    },
  },
  methods: {
    goToUrl() {
      window.location.href = "https://www.topdesk.com/";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
</style>
